import pluralize from "pluralize";
import {Fragment} from "react";

import {Card} from "@/components/card/Card.tsx";
import {Divider} from "@/components/divider/Divider.tsx";

import styles from "./MaintenanceItemList.module.scss";

export interface MaintenanceListItem {
  id: number;
  name: string;
  services_count: number;
}

export interface MaintenanceItemListProps {
  items: MaintenanceListItem[];
}

export const MaintenanceItemList = ({items}: MaintenanceItemListProps) => (
  <div className={styles.scroll}>
    <Card variant="defaultBorderless" className={styles.card}>
      {items.map((item, index) => (
        <Fragment key={item.id}>
          {index > 0 && <Divider color="subMenu" />}
          <div className="d-flex justify-content-between align-items-center gap-3">
            <div className="ellipsis-overflow pulseTextBodySmall pulse-color-gray-900">{item.name}</div>
            <div className="text-nowrap pulseTextBodySmall pulse-color-gray-600">
              {pluralize("check", item.services_count, true)}
            </div>
          </div>
        </Fragment>
      ))}
    </Card>
  </div>
);
